import { LanguageSelector } from '@/components/question/forms/LanguageSelector';
import { Question } from '@/models/Question';
import {
  DEFAULT_LANGUAGE,
  SupportedLanguage,
} from '@/models/TranslatableField';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { QuestionView } from '@/components/question/view/QuestionView';

type QuestionPreviewProps<T extends Question> = {
  question: T;
};

export default function QuestionPreview<T extends Question>({
  question,
}: QuestionPreviewProps<T>) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.questionsTab.createQuestionModal',
  });
  const [language, setLanguage] = useState<SupportedLanguage>(DEFAULT_LANGUAGE);

  return (
    <section
      aria-label={t('previewTitle')}
      className="min-h-[300px] py-4 gap-6 flex flex-col"
    >
      <div className="flex w-full items-center justify-between">
        <h3 className="text-base font-semibold text-base-content">
          {t('previewTitle')}
        </h3>
        <LanguageSelector
          activeLanguage={language}
          onLanguageChange={setLanguage}
        />
      </div>
      <QuestionView
        question={question}
        value={null}
        mode="reviewing"
        language={language}
      />
    </section>
  );
}
